export default {
  NOT_FOUND: 'notfound',
  ANTIFORGERY: 'antiforgery',
  FROZEN_IS_Pregnant: 'frozenIsPregnant',
  UNAUTHORIZED: 'unauthorized',
};
